export default __webpack_public_path__ + "static/media/blackLogo.0803b9a0.png";